@if (imageMap) {
	<map [attr.name]="imageMap.name">
		@for (area of imageMap.areas; track area) {
			<!-- eslint-disable-next-line -- Eslint can not handle area tags. Should be fixed in future eslint versions -->
			<area
				[shape]="area.shape"
				[coords]="
					area.coords
						| zoom
							: getXZoomFactor(imageMap, width(), originalWidth())
							: getYZoomFactor(imageMap, height(), originalHeight())
				"
				[alt]="area.alt"
				[title]="area.title"
				[href]="getHref(area)"
				[target]="getTarget(area)"
				rel="noopener noreferrer"
			/>
		}
	</map>
}
